document.addEventListener('DOMContentLoaded', function () {
  class BlockOffersPush extends HTMLElement {
    constructor() {
      super();
      this.filterSelector = '.js-offers-push__filter';
      this.offers = this.querySelectorAll('.js-offers-push__type');
    }
    connectedCallback() {
      // props

      // elements

      // bindings
      this.bndHandleClick = this.handleClick.bind(this);

      // events
      this.addEventListener('click', this.bndHandleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.bndHandleClick);
    }
    toggleOffers(on) {
      const offers = Array.from(this.offers);
      if (offers.length > 0) {
        offers.forEach(offer => {
          if (on) {
            offer.removeAttribute('hidden');
          } else {
            offer.setAttribute('hidden', '');
          }
        });
      }
    }
    toggleFilters(on) {
      const filters = Array.from(this.querySelectorAll(this.filterSelector));
      if (filters.length > 0) {
        filters.forEach(offer => {
          if (on) {
            offer.setAttribute('aria-current', 'true');
          } else {
            offer.removeAttribute('aria-current');
          }
        });
      }
    }
    handleClick(event) {
      const trigger = event.target.closest(this.filterSelector);
      if (!trigger) return;
      event.preventDefault();
      const url = new URL(trigger.href);
      const hash = url.hash.slice(1);
      const target = hash ? this.querySelector(`#${hash}`) : null;
      this.toggleFilters(false);
      trigger.setAttribute('aria-current', 'true');
      if (!target) {
        this.toggleOffers(true);
      } else {
        this.toggleOffers(false);
        target.removeAttribute('hidden');
      }
    }
  }
  customElements.define('block-offers-push', BlockOffersPush);
});